import React from "react";

export default (props) => {
  const { value, style } = props;

  return <strong style={style}>{value}</strong>;
}
